import React from 'react'
import PropTypes from 'prop-types'
import SearchIcon from './icons/SearchIcon'
import TextInput from './TextInput'

const ICON_CLASSES = 'tw:h-5 tw:w-5 tw:absolute tw:left-3 tw:top-1/2 tw:-translate-y-1/2 '
  + 'tw:pointer-events-none tw:text-gray-500'

const INPUT_CLASSES = 'tw:pl-10! tw:text-sm! tw:leading-normal! '
  + 'tw:border-gray-300! tw:focus:border-ds-primary!'

// The DS control height, so a search field lines up with the buttons beside it.
const DEFAULT_INPUT_SIZE = 'tw:h-10!'

const SearchInput = ({
  className = '', inputClassName = DEFAULT_INPUT_SIZE, name, onChange,
  placeholder = '', value = ''
}) => (
  <div className={`tw:relative ${className}`.trim()}>
    <TextInput
      className={`${INPUT_CLASSES} ${inputClassName}`.trim()}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
    <SearchIcon className={ICON_CLASSES} />
  </div>
)

SearchInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string
}

SearchInput.defaultProps = {
  className: '',
  inputClassName: DEFAULT_INPUT_SIZE,
  placeholder: '',
  value: ''
}

export default SearchInput
